export function Spinner() {
  return <div className="spinner" />;
}
